import React, { useState } from "react";
import { RiInstagramLine, RiWhatsappFill } from "react-icons/ri";
import { Link } from "react-router-dom";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log("Newsletter subscription:", email);
    setEmail("");
  };

  return (
    <footer className="bg-[#0A0A0A] text-white font-Poppins">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 py-12 md:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row justify-between gap-12 lg:gap-20">
          {/* Left Section - Brand & Newsletter */}
          <div className="space-y-8">
            {/* Brand Name */}
            <div>
              <h2 className="text-[#C8960C] text-4xl md:text-[32px] font-bold tracking-tight">
                Makalu Agro & Trade
              </h2>
              <p className="text-white/80 text-base md:text-[16px] mt-3 leading-relaxed">
                Welcome to the world of highest - Quality Rudraksha
              </p>
            </div>

            {/* Newsletter Form */}
            <div className="max-w-md w-full">
              <form
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3"
              >
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  required
                  className="w-full flex-1 bg-[#1A1A1A] text-white placeholder:text-white/40 px-4 py-2.5 rounded-full outline-none focus:ring-2 focus:ring-[#C8960C]/50 transition-all duration-300 text-[14px] md:text-[16px]"
                />
                <button
                  type="submit"
                  className="w-full sm:w-auto bg-white text-black font-semibold px-6 py-2.5 rounded-full hover:bg-[#C8960C] hover:text-white transition-all duration-300 text-sm md:text-[12px] whitespace-nowrap"
                >
                  JOIN
                </button>
              </form>
            </div>
          </div>

          {/* Right Section - Social Links */}
          <div className="flex flex-col justify-between">
            <div>
              <h3 className="text-white/50 text-[8px] md:text-[10px] font-medium tracking-wider uppercase mb-6">
                CONNECT
              </h3>
              <div className="space-y-4">
                <Link
                  to="https://www.instagram.com/makalurudraksha?igsh=ZDFuNmUyZHd3ZWUy&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-[12px] md:text-[16px] hover:text-[#C8960C] transition-colors duration-300 group"
                >
                  <RiInstagramLine className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
                  <span>Instagram</span>
                </Link>

                <Link
                  to="https://wa.me/message/VBRZKTRUMMRWO1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-[12px] md:text-[16px] hover:text-[#C8960C] transition-colors duration-300 group"
                >
                  <RiWhatsappFill className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
                  <span>whatsapp</span>
                </Link>
                {/* <Link
                  to="https://www.twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-[12px] md:text-[16px] hover:text-[#C8960C] transition-colors duration-300 group"
                >
                  <RiTwitterLine className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
                  <span>Twitter</span>
                </Link> */}
                {/* <Link
                  to="https://www.youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-[12px] md:text-[16px] hover:text-[#C8960C] transition-colors duration-300 group"
                >
                  <RiYoutubeLine className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
                  <span>YouTube</span>
                </Link> */}
                {/* <Link
                  to="https://www.tiktok.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-[12px] md:text-[16px] hover:text-[#C8960C] transition-colors duration-300 group"
                >
                  <FaTiktok className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
                  <span>TikTok</span>
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t bg-[#1A1400] border-[#3D2D00]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-[#C8960C]/80 text-[12px] md:text-[14px]">
            <p className="text-center">© Makalu 2025 All rights reserved</p>
            <span className="hidden sm:inline">|</span>
            <div className="flex items-center gap-3 sm:gap-4">
              <Link
                to="/terms-of-use"
                className="hover:text-[#C8960C] transition-colors duration-300 underline"
              >
                Terms of Use
              </Link>
              <span>|</span>
              <Link
                to="/privacy-policy"
                className="hover:text-[#C8960C] transition-colors duration-300 underline"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
